import TaggedButton from '@components/TaggedButton';
import { useMultipleCommentsExcelUpload } from '@modules/comment/src/commentMutations';
import { useMultipleCommentsExcelDownload } from '@modules/comment/src/commentQueries';
import { ColumnsType } from 'antd/es/table';
import {
  Alert, Divider, Form, Table, UploadProps,
} from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import { FC, useState } from 'react';
import TaggedModal from '../../../components/TaggedModal';
import TaggedFileUpload from '../../../components/inputs/TaggedFileUpload';
import styles from './styles.module.less';

interface UploadMultipleCommentsExcelModalProps {
  closeModal: () => void;
  showModal: boolean;
}

const UploadMultipleCommentsExcelModal: FC<UploadMultipleCommentsExcelModalProps> = (props) => {
  const {
    closeModal,
    showModal,
  } = props;

  const [filelist, setFileList] = useState<Blob>();

  const { mutate, isLoading } = useMultipleCommentsExcelUpload(closeModal);
  const { refetch: downloadTemplate, isFetching: isDownloadTemplateLoading } = useMultipleCommentsExcelDownload();

  const onUploadExcel = () => {
    const formData = new FormData();
    formData.append('file', filelist!);
    mutate(formData);
  };

  const uploadFileProps: UploadProps = {
    beforeUpload: (file) => {
      setFileList(file);
      return false;
    },
    maxCount: 1,
  };

  const columns: ColumnsType<comment.MultipleCommentsAlertData> = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 100,
      render: (text: string) => <strong>{text}</strong>,
    },
    {
      title: 'investment_note_name',
      dataIndex: 'investment_note_name',
      key: 'investment_note_name',
      align: 'center',
    },
    {
      title: 'investment_note_id',
      dataIndex: 'investment_note_id',
      key: 'investment_note_id',
      align: 'center',
    },
    {
      title: 'supplier_name',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      align: 'center',
      render: (text: string) => (
        <span style={{ whiteSpace: 'pre-line' }}>{text}</span>
      ),
    },
    {
      title: 'buyer_name',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      align: 'center',
    },
    {
      title: 'comment',
      dataIndex: 'comment',
      key: 'comment',
      align: 'center',
    },
    {
      title: 'Special Note',
      dataIndex: 'special_note',
      key: 'special_note',
    },
  ];

  const data = [
    {
      key: '1',
      type: 'Invoices',
      investment_note_name: '🟡',
      investment_note_id: '🟡',
      supplier_name: '✅',
      buyer_name: '🟡',
      comment: '✅',
      special_note: 'If only supplier_name is provided, the comment will be applied to Invoices associated with that supplier only.',
    },
    {
      key: '2',
      type: 'Term Loans',
      investment_note_name: '✅',
      investment_note_id: '✅',
      supplier_name: '✅\n(use as Issuer Name)',
      buyer_name: '🚫',
      comment: '✅',
      special_note: '',
    },
  ];

  return (
    <TaggedModal
      open={showModal}
      tag="uploadMultipleCommentsExcel"
      title="Upload Multiple Comments Excel"
      onCancel={closeModal}
      okText="Submit"
      okButtonProps={{
        htmlType: 'submit', form: 'uploadMultipleCommentsExcel', loading: isLoading,
      }}
      destroyOnHidden
      centered
      width={1000}
    >
      <Alert
        message="Notes:"
        type="info"
        description={
          (
            <Paragraph className={styles['mb-0']}>
              <ul>
                <li>
                  🟡 Optional
                </li>
                <li>
                  ✅ Required
                </li>
                <li>
                  🚫 Not applicable
                </li>
              </ul>
              <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                size="small"
                bordered
                className="mb-3"
                scroll={{
                  x: true,
                }}
              />
              Click
              {' '}
              <TaggedButton tag="downloadExcel" size="small" onClick={() => downloadTemplate()} disabled={isDownloadTemplateLoading}>
                HERE
              </TaggedButton>
              {' '}
              to download sample excel upload file.
            </Paragraph>
          )
        }
      />
      <Divider />
      <Form onFinish={onUploadExcel} id="uploadMultipleCommentsExcel" layout="vertical">
        <Form.Item
          label="Only xlsx/xls file is allowed"
          name="multipleCommentsExcel"
          rules={[{ required: true, message: 'Please select a file' }]}
        >
          <TaggedFileUpload accept=".xlsx, .xls" tag="uploadMultipleCommentsExcel" {...uploadFileProps} />
        </Form.Item>
      </Form>
    </TaggedModal>
  );
};

export default UploadMultipleCommentsExcelModal;
